export default "__VITE_ASSET__TwpIBtCn__ 640w, __VITE_ASSET__65zJsTBE__ 1024w, __VITE_ASSET__ZhTXlfoQ__ 1280w";